import { lazy, Suspense } from 'react'
import { Box, Flex, Spinner, useColorModeValue } from '@chakra-ui/react'
import { Routes, Route } from 'react-router-dom'

import { PRICE_DISCLAIMER } from '../config/app'
import { Disclaimer } from './Disclaimer'
import Footer from './Footer'
import Landing from '../pages/Landing'

// Route components are code-split so the landing route ("/") does not ship the
// dashboards/admin code. React.lazy is a clean dynamic-import boundary, which
// Vite splits into its own async chunk by the dependency graph — unlike the
// manualChunks grouping that was removed for causing init-order blank-page bugs.
const CampaignDirectory = lazy(() => import('../pages/CampaignDirectory'))
const CampaignOverview = lazy(() => import('../pages/CampaignOverview'))
const GlobalSacrificeDashboard = lazy(() => import('./GlobalSacrificeDashboard'))
const UserSacrificesPage = lazy(() => import('../pages/UserSacrificesPage'))
const AdminDashboard = lazy(() => import('../pages/AdminDashboard'))
const CampaignComposer = lazy(() => import('../pages/CampaignComposer'))
const DerivationWizard = lazy(() => import('../pages/DerivationWizard'))
const InstanceDashboard = lazy(() => import('../pages/InstanceDashboard'))

/**
 * AppContent - Main content area with Routes
 *
 * This component wraps the Routes content.
 * The loader hiding is handled in main.tsx via requestAnimationFrame.
 */
const AppContent = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.900')

  return (
    <Flex direction="column" minH="100vh" bg={bgColor} gap={8} pb={{ base: '60px', lg: 0 }}>
      {/* Indexing progress modal - dismissable */}
      {/* <IndexingProgressBadge /> */}
      <Box as="main" w="100%" mx="auto" flex="1">
        <Suspense
          fallback={
            <Flex justify="center" align="center" minH="50vh">
              <Spinner size="xl" thickness="3px" color="blue.400" />
            </Flex>
          }
        >
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/compose" element={<CampaignComposer />} />
            <Route path="/sacrifices" element={<CampaignDirectory />} />
            <Route path="/instance" element={<InstanceDashboard />} />
            <Route path="/sacrifice/:project_id">
              <Route index element={<CampaignOverview />} />
              <Route path="global" element={<GlobalSacrificeDashboard />} />
              <Route path="user/:address" element={<UserSacrificesPage />} />
              <Route path="user" element={<UserSacrificesPage />} />
              <Route path="admin" element={<AdminDashboard />} />
              <Route path="admin/derive" element={<DerivationWizard />} />
            </Route>
          </Routes>
        </Suspense>
      </Box>
      <Box px={4}>
        <Flex maxW="container.xl" w="100%" mx="auto">
          <Disclaimer disclaimerText={PRICE_DISCLAIMER} />
        </Flex>
      </Box>
      <Footer />
    </Flex>
  )
}

export default AppContent
